module.exports = __webpack_public_path__ + "static/media/Building A-1-Meter_MDB-A_Area.eb9f368d.jpg";